import React from 'react';

import track from 'react-tracking';
import layoutWithNavbar from 'layouts/withNavbar';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import './ThankYou.scss';
import BigCheckIcon from 'assets/icons/big-check.svg';
import classNames from 'classnames';
import { getRTL } from 'shared/redux/selectors';
import { saveUserRating } from 'shared/redux/actions';
import { connect } from 'react-redux';
import { RatingStar, BotTyping } from 'components';
// import { PATH } from 'shared/constants';

import trackEvent from 'components/TrackEvent';
import { eventGetInTouchCompleted } from 'components/TrackEvent/constEvent';
import ultilitiesService from 'shared/util/ultilitiesService';
import { trackCompleteProspect } from './CallToAction.tracking';

const ThankYou = ({
  intl,
  summary,
  onSaveUserRating,
  rating,
  // CMAClassification,
  isRtl,
  refCode,
  tracking,
  currentLocale,
}) => {
  const classes = classNames({
    'thank-you': true,
    'thank-you--rtl': isRtl,
  });


  return (
    <section className={classes}>
      <h1>{intl.formatMessage({ id: 'thankYou' })}</h1>
      <FormattedMessage id="thankYou.refCode">
        {
            txt => (
              <p className="thank-you__code">
                <span>{txt}</span>
                {refCode ? <strong>{refCode}</strong> : <BotTyping alwaysShow />}
              </p>
            )
          }
      </FormattedMessage>
      <article>
        <img src={BigCheckIcon} alt="Thank you" />
        <p><strong>{intl.formatMessage({ id: 'thankYou.dearUser' }, { user: summary && summary['summary.name'] })}</strong></p>

        {summary['summary.proceedOption'] !== 'open_account' && (
          <p>{intl.formatMessage({ id: `thankYou.${summary['summary.proceedOption']}` })}</p>
        )}

        {summary['summary.proceedOption'] === 'open_account' && (
          <>
            {summary.hasOwnProperty('summary.applicationVia') && summary['summary.applicationVia'] === 'go_to_cob' ? (
              <>
                <p><FormattedHTMLMessage id="thankYou.open_account" values={{ link: `${process.env.REACT_APP_COB_URL}/login?refCode=${refCode}` }} /></p>
                <p>{intl.formatMessage({ id: 'thankYou.open_account2' })}</p>
              </>
            ) : (
              <p><FormattedHTMLMessage id="thankYou.open_account_email" values={{ link: `${process.env.REACT_APP_COB_URL}/login?refCode=${refCode}` }} /></p>
            )}
          </>
        )}

        <p><small>{intl.formatMessage({ id: 'thankYou.notes' })}</small></p>
      </article>

      <p><FormattedMessage id="thankYou.howYouRate" /></p>
      <RatingStar
        onSaveUserRating={(value) => {
          onSaveUserRating(value);
          if (refCode) {
            ultilitiesService.handleCompleteProspect(refCode, summary, intl, tracking, value, trackCompleteProspect);
          }
          /** */
          // trackUserExperience(tracking, value);
          /** */
          trackEvent(eventGetInTouchCompleted(currentLocale, summary ? summary['summary.email'] : ''));
        }}
        rating={rating}
      />
    </section>
  );
};

const mapStateToProps = state => ({
  summary: state.rootReducer.summary,
  rating: state.rootReducer.userInfo.rating,
  isRtl: getRTL(state.rootReducer),
  refCode: state.ctaReducer.referenceCode,
  CMAClassification: state.rootReducer.CMAClassification,
  currentLocale: state.rootReducer.language.locale,
});

const mapDispatchToProps = ({
  onSaveUserRating: saveUserRating,
});

export default track({
  page: 'ThankYou',
})(
  connect(mapStateToProps, mapDispatchToProps)(layoutWithNavbar(injectIntl(ThankYou))),
);
